// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_a53de5","linkedinIcon":"_0c2411","badge":"_805d12"};